import styled from 'styled-components';
import { Styles } from '@gv/triage-components';

const { bodySemibold } = Styles.Font;

export const Text = styled.p`
  ${bodySemibold};
  min-width: 36px;
`;
